import type { TemperatureType, VehicleTypes } from '@hero/schema';

/**
 * Derive the `temperatureType` for a route row from the selected vehicles.
 *
 * The Hero vehicle taxonomy only carries one temperature signal — the
 * `*_chilled` variants (`truck_chilled`, `dyna_chilled`, `lorry_chilled`,
 * `van_chilled`). Everything else is ambient by default. By inferring the
 * temperature from the vehicle pick we remove a redundant column from the
 * pricing sheet while still satisfying `RouteCreateAPI.temperatureType`.
 *
 * If the user mixes chilled + non-chilled vehicles in one row we conservatively
 * widen the lane to `['dry', 'chilled']` so the resolver can still match the
 * row for either fleet kind.
 */
export function deriveTemperatureFromVehicles(
  vehicles: VehicleTypes[],
): TemperatureType[] {
  if (vehicles.length === 0) return ['dry'];

  const hasChilled = vehicles.some(v => v.endsWith('_chilled'));
  const hasAmbient = vehicles.some(v => !v.endsWith('_chilled'));

  if (hasChilled && hasAmbient) return ['dry', 'chilled'];
  if (hasChilled) return ['chilled'];
  return ['dry'];
}
